import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../lib/api";
import { getRankIcon, isErRank } from "../lib/ranks";
import "./KabileLeaderPanel.css";

interface Top3Answer {
  _id: string;
  userId: string;
  username: string;
  userTP: number;
  userRank: string;
  answerText: string;
  votes: number;
  isLeaderChoice: boolean;
}

export default function KabileLeaderPanel() {
  const [loading, setLoading] = useState(true);
  const [top3, setTop3] = useState<Top3Answer[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadTop3();
  }, []);

  const loadTop3 = async () => {
    try {
      setLoading(true);
      const res = await apiGet<{ ok: true; top3: Top3Answer[] }>(
        "/api/kabile/daily-battle/top3"
      );
      setTop3(res.top3);
      
      // Eğer zaten seçilmişse göster
      const selected = res.top3.find(a => a.isLeaderChoice);
      if (selected) {
        setSelectedId(selected._id);
      }
    } catch (error: any) {
      console.error("Failed to load top 3:", error);
      alert(error.message || "TOP 3 yüklenirken hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (answerId: string) => {
    if (selectedId) {
      alert("Zaten bir cevap seçtiniz. Seçiminiz değiştirilemez!");
      return;
    }

    if (!confirm("Bu cevabı global arenaya göndermek istediğinizden emin misiniz?\n\nBu işlem geri alınamaz!")) {
      return;
    }

    try {
      setSubmitting(true);
      await apiPost("/api/kabile/daily-battle/select", { answerId });
      setSelectedId(answerId);
      alert("Cevap global arenaya gönderildi! 🎉");
      await loadTop3();
    } catch (error: any) {
      console.error("Failed to select answer:", error);
      alert(error.message || "Cevap seçilirken hata oluştu");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="leader-panel">
        <div className="panel-loading">TOP 3 yükleniyor...</div>
      </div>
    );
  }

  if (top3.length === 0) {
    return (
      <div className="leader-panel">
        <div className="panel-header">
          <h3>👑 Lider Paneli - TOP 3 Seçimi</h3>
        </div>
        <div className="panel-empty">
          Henüz cevap yok. Kabile üyeleri cevap yazdığında burada görünecek.
        </div>
      </div>
    );
  }

  return (
    <div className="leader-panel">
      <div className="panel-header">
        <h3>👑 Lider Paneli - Cevap Seçimi</h3>
        <p className="panel-subtitle">
          {selectedId 
            ? "✅ Global arenaya cevap seçtiniz" 
            : `En çok oy alan ${top3.length > 1 ? top3.length + ' cevaptan' : 'cevabı'} birini seçip global arenaya gönderin`}
        </p>
      </div>

      <div className="top3-list">
        {top3.map((answer, index) => (
          <div
            key={answer._id}
            className={`top3-card ${selectedId === answer._id ? "selected" : ""}`}
          >
            <div className="top3-rank">
              {index === 0 && "🥇"}
              {index === 1 && "🥈"}
              {index === 2 && "🥉"}
              <span className="rank-number">#{index + 1}</span>
            </div>

            <div className="top3-content">
              <div className="top3-author">
                <span className="author-name">{answer.username}</span>
                <span className="author-stats">
                  ⚜️ {answer.userTP} TP | 
                  {isErRank(Number(answer.userRank)) ? (
                    <span className="er-rank-emoji">🟢</span>
                  ) : (
                    <img 
                      src={getRankIcon(Number(answer.userRank))} 
                      alt="rank" 
                      className="top3-rank-icon"
                    />
                  )}
                </span>
              </div>

              <div className="top3-answer-text">{answer.answerText}</div>

              <div className="top3-footer">
                <span className="top3-votes">👍 {answer.votes} oy</span>
                
                {!selectedId && (
                  <button
                    onClick={() => handleSelect(answer._id)}
                    disabled={submitting}
                    className="select-btn"
                  >
                    🚀 Global Arenaya Gönder
                  </button>
                )}

                {selectedId === answer._id && (
                  <span className="selected-badge">✅ Seçildi</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {!selectedId && (
        <div className="panel-warning">
          ⚠️ Dikkat: Bir kez seçtikten sonra değiştiremezsiniz!
        </div>
      )}
    </div>
  );
}
